import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import QuoteModal from "../components/QuoteModal";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import VideoEditing from "../components/sections/VideoEditing";
import Portfolio from "../components/sections/Portfolio";
import VideoShowcase from "../components/sections/VideoShowcase";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";
import { api } from "../lib/api";

export default function Home() {
  const [services, setServices] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [settings, setSettings] = useState(null);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get("/services").then((r) => r.data).catch(() => []),
      api.get("/portfolio").then((r) => r.data).catch(() => []),
      api.get("/testimonials").then((r) => r.data).catch(() => []),
      api.get("/settings").then((r) => r.data).catch(() => null),
    ]).then(([s, p, t, st]) => {
      setServices(s);
      setPortfolio(p);
      setTestimonials(t);
      setSettings(st);
    });
  }, []);

  const openQuote = () => setQuoteOpen(true);

  return (
    <div data-testid="home-page" className="bg-white">
      <Navbar onQuoteClick={openQuote} />
      <main>
        <Hero onQuoteClick={openQuote} />
        <Portfolio items={portfolio} />
        <Services items={services} onQuoteClick={openQuote} />
        <VideoEditing onQuoteClick={openQuote} />
        <VideoShowcase />
        <WhyChooseUs />
        <Testimonials items={testimonials} />
        <About />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
      <FloatingWhatsApp number={(settings?.whatsapp || "919999999999").replace(/[^\d]/g, "")} />
      <QuoteModal open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}
